import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AppManager from "../../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import Utility, { deepClone } from "../../../utility/Utility";
import AddTimesheetReport from "./AddTimesheetReport";
import { fetchBooksContact, selectBooksContact } from "../../../Redux/Slices/BooksContactSlice";
import { fetchProject, selectProject } from "../../../Redux/Slices/ProjectSlice";
import { fetchTask, selectTask } from "../../../Redux/Slices/TaskSlice";
import { fetchEmployeeListWithoutFilter, selectEmployeeListWithoutLimit } from "../../../Redux/Slices/EmployeeListSlice";
import moment from "moment";
import TimesheetService, { TIMESHEET_CONSTANTS } from "../TimesheetService";
import i18next from "i18next";
import {
    DKIcons,
    TOAST_TYPE,
    showToast,
    showLoader,
    removeLoader,
    DKDateRangePicker,
    DKListPicker2,
    DKButton,
    showAlert,

} from "deskera-ui-library";
import TimesheetUtils from "../TimesheetUtils";
import FormatCurrencyService from "../../../services/FormatCurrencyService";
import { DATE_FORMAT } from "../../../constants/Constant";
import ic_arrow_back from "../../../assets/icons/ic_arrow_back.svg";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

function TimesheetReport(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const initialState = {
        columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT),
        rowData: [],
        originalData: [],
        filter: []
    };

    const initialYear = {
        toggle: false,
        startDate: moment(moment().format()).startOf('month'),
        endDate: moment(moment().format()).endOf('month'),
        defaultDate: false,
        hasError: false,
        errorMsg: 'End date should not be less than Start date'
    };

    const booksContact = useSelector(selectBooksContact);
    const project = useSelector(selectProject);
    const task = useSelector(selectTask);
    const employeeResponse = useSelector(selectEmployeeListWithoutLimit);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [showSpinner, setSpinner] = useState(false);
    const [timesheetData, setTimesheetData] = useState(initialState);
    const [showAddTimesheet, setShowAddTimesheet] = useState(false);
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [fromDate, setFromDate] = useState(moment().startOf("month").startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("month").endOf("day"));
    const [filterArray,setFilterArray] = useState([]);
    const [reload, setReload] = useState(false);
    
    const [filterCustomerPopup,setFilterCustomerPopup] = useState({
        show:false,
        value:'All'
    })
    const [customer,setCustomer] = useState([])
    const [selectYear, setYear] = useState(initialYear);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        const rowData = []
        const Column = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);
        const passingData = {
            columnData: deepClone(Column),
            rowData,
            filter: '',
            originalData: rowData
        };
        setTimesheetData(passingData);
        fetchDependencies()
        getReport({
            currentPage: 1,
            limit: 20,
            fromDate: moment().startOf("month").startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            toDate: moment().endOf("month").endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            searchString:''
        });
    }, []);

    useEffect(() => {
        if (!Utility.isEmpty(booksContact)) {
            const columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);;
            const ind = columns.findIndex(c => c.columnCode === 'customerId')
            if (ind !== -1) {
                columns[ind].options = booksContact?.map(e => { return { ...e, name: e.name, id: e.customer, id: e.id.toString() } }) || []
                setTimesheetData({
                    ...timesheetData,
                    columnData: columns
                });
            }

        }
    }, [booksContact,reload]);

    useEffect(() => {
        if (!Utility.isEmpty(project)) {
            const columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);;
            const ind = columns.findIndex(c => c.columnCode === 'projectId')
            if (ind !== -1) {
                columns[ind].options = project?.data?.map(e => { return { ...e, name: e.name, id: e.id } }) || []
                setTimesheetData({
                    ...timesheetData,
                    columnData: columns
                });
            }
        }
    }, [project,reload]);

    useEffect(() => {
        if (!Utility.isEmpty(task)) {
            let columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);;
            const ind = columns.findIndex(c => c.columnCode === 'jobId')
            if (ind !== -1) {
                columns[ind].options = task?.data?.map(e => { return { ...e, name: e.name, id: e.id } }) || []
                setTimesheetData({
                    ...timesheetData,
                    columnData: columns
                });
            }
        }
    }, [task,reload]);

    useEffect(() => {
        if (!Utility.isEmpty(employeeResponse)) {
            let columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);;
            const ind = columns.findIndex(c => c.columnCode === 'employeeId')
            if (ind !== -1) {
                columns[ind].options = employeeResponse?.users?.map(e => { return { ...e, name: e.name, id: e.userId } }) || []
                setTimesheetData({
                    ...timesheetData,
                    columnData: columns
                });
            }

        }
    }, [employeeResponse,reload]);

    const fetchDependencies = async () => {
        const dependencies = [
            dispatch(fetchEmployeeListWithoutFilter()),
            dispatch(fetchBooksContact()),
            dispatch(fetchTask()),
            dispatch(fetchProject()),
            TimesheetService.getCustomers(false)
        ]        
        const response = await Promise.all(dependencies);
        setCustomer(response[4] || [])
    }

    const getReport = (config) => {
        showLoader("Loading... Please wait")
        TimesheetService.REPORTS_API_CONFIG = { ...config }
        TimesheetService.getReportData(config).then(
            (response) => {
                removeLoader()
                if (Array.isArray(response?.data)) {
                    setTimesheetData({
                        ...timesheetData,
                        rowData: formatRowDate(response.data)
                    })
                    setCurrentPage(parseInt(response.filterConfig.page));
                    setTotalPageCount(response.filterConfig.totalPage);
                }
            }, (error) => {
                removeLoader()
                showToast("Error while getting timesheet entries, Please try after sometime.", TOAST_TYPE.FAILURE);
            }
        );
    }
    const getFunctionConfig = () =>{
        return {
            "onRowDelete":onRowDelete,
            "onApproveReject":onApproveReject,
            "onSubmit":onSubmit
        }
    }
    const formatRowDate = (data) => {
        const rowData = [];
        const functionConfig = getFunctionConfig()
        data.forEach(row => {
            rowData.push({
                ...row,
                jobId: row.jobName,
                projectId: row.projectName,
                customerId: [row.customer],
                date: [moment((row.fromDate)).format('YYYY-MM-DD')],
                fromDate: [moment((row.fromDate)).format('hh:mm A')],
                toDate: [moment(row.toDate).format('hh:mm A')],
                status: [row.status],
                isBillable: row.isBillable ? "Yes" : "No",
                employeeId: row.employeeName,
                hours: TimesheetUtils.getTimeInString(row.seconds),
                ratePerHour: `${FormatCurrencyService.format(row.ratePerHour)}`,
                amount: `${FormatCurrencyService.format(row.amount)}`,
                dataObj: row,
                rowContextMenu: TimesheetUtils.getReportContextMenuButton(row,functionConfig)

            })
        });

        return rowData;
    }

    const onRowDelete = (data) => {
        if (data?.rowData) {
            if (data.rowData.status === "APPROVED" || data.rowData.status === "REJECTED" || data.rowData.status === TIMESHEET_CONSTANTS.SUBMITTED) {
                showToast("Not allowed to delete admin submitted/approved/rejected timesheet entry.", TOAST_TYPE.WARNING);
                return;
            }

            const payload = {
                ids: [`${data.rowData.id}`]
            };

            showLoader("Deleting timesheet entry... Please wait");
            TimesheetService.deleteTimesheetEntry(payload).then(
                (response) => {
                    removeLoader();
                    showToast("Deleted timesheet entry successfully.", TOAST_TYPE.SUCCESS);
                    getReport({ ...TimesheetService.REPORTS_API_CONFIG });
                }, (error) => {
                    removeLoader();
                    if (error?.message) {
                        showToast(error.message, TOAST_TYPE.FAILURE);
                    } else {
                        showToast("Error while deleting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        }
    }

    const onRowEdit = (data) => {
        TimesheetService.REPORT = data.rowData.dataObj;
        setShowAddTimesheet(true);
    }

    const updateRowExpanded = (data) => { }

    const refresh = (data) => { }

    const onSearch = (data) => {
        const config = {
            ...TimesheetService.REPORTS_API_CONFIG,
            searchString: data
        }
        getReport(config);
    }

    const onFilter = (updatedList, queries) => {
        
        const oldQuery = deepClone(queries)
        const config = {
            ...TimesheetService.REPORTS_API_CONFIG,
            fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            toDate: toDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        }
        if(queries && queries.length === 0) {
            delete config['status']
            delete config['projectId']
            delete config['jobId']
            delete config['customerId']
            delete config['isBillable']
            delete config['employeeId']
        }
        let columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT)), TABLES.PEOPLE_TIMESHEET_REPORT);;
        queries.forEach(f => {
            const ind = columns.findIndex(c => c.id === f.key)
            if (ind !== -1) {
                if (f.key === 'bill') {
                    config['isBillableFilter'] = true;
                    config['isBillableValue'] = f?.value[0]
                } else {
                    config[columns[ind].columnCode] = f?.value[0]
                }

            }
        }
        )
        setFilterArray(oldQuery)
        getReport(config);
    }

    const onRowAdd = (data) => { }

    const onRowSelect = (data) => { }

    const getDatePickerTitle = () => {
        return `${Utility.formatDate(fromDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)} - ${Utility.formatDate(toDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)}`;
    }

    const renderDateRangePicker = () => {
        return (
            <div className="position-absolute bg-white z-index-6 rounded border-m" style={{ top: 89, right: 160 }}>
                <DKDateRangePicker
                    className="border shadow "
                    color={'rgb(0, 102, 65)'}
                    startDate={fromDate.toDate()}
                    selectedStartDate={fromDate.toDate()}
                    selectedEndDate={toDate.toDate()}
                    onSelectDateRange={(startDate, endDate) => {
                        if (startDate && endDate) {
                            setFromDate(moment(startDate).startOf("day"));
                            setToDate(moment(endDate).endOf("day"));
                            setShowDateRangePicker(false);
                            setCurrentPage(1);
                            const config = {
                                ...TimesheetService.REPORTS_API_CONFIG,
                                fromDate: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                                toDate: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                            };
                            
                            getReport(config);
                        }
                    }}
                    onClose={() => {
                        setShowDateRangePicker(false);
                    }}
                />
            </div>
        );
    }
    const onSubmit=(data)=>{
        let payload
        if (data?.rowData) {
            if (data.rowData.status === "APPROVED" ) {
                showAlert("Info","Not allowed to submit admin approved timesheet entry.");
                return;
            }
            if( Utility.isEmpty(data.rowData?.toDate)) {
                showToast("Please stop timer to submit draft Timesheet entry")
                return
            }
            payload = {
                ids: [`${data.rowData.id}`]
            };

            TimesheetService.submitTimesheetEntry(payload).then(() => {
                showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                
                const config = {
                    ...TimesheetService.REPORTS_API_CONFIG,
                }
                getReport(config);
            })  
        }
    }
    const onApproveReject = (data,isApprove)=>{
        
        if(data?.rowData) {
            const payload = {
                status: isApprove ? TIMESHEET_CONSTANTS.APPROVED:TIMESHEET_CONSTANTS.REJECTED,
                ids : [data?.rowData?.id]
            }
            TimesheetService.updateTimesheetStatus(payload).then(() => {
            showToast("Timesheets updated", TOAST_TYPE.SUCCESS);
            const config = {
                ...TimesheetService.REPORTS_API_CONFIG,
            }
            getReport(config);
            })
        }
    }
    const addButtonConfig = () => {
      const addEntryButton = {
        title: `+ ${"Timesheet Entry"}`,
        className: "bg-app text-white ml-s",
        onClick: () => {
          setShowAddTimesheet(true);
        },
      };
      let finalBtnConfig = [];
      if (PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.CREATE])) {
        finalBtnConfig.push(addEntryButton);
      }
      return [
        ...finalBtnConfig,
        {
          title: getDatePickerTitle(),
          icon: DKIcons.ic_calendar,
          className: "bg-white ml-s border-m",
          onClick: () => {
            setShowDateRangePicker(true);
          },
        },
      ];
    };

    const addMenuButton = () => {
        let menuBtn = []
        const approveBtn = {
            title: i18next.t(TIMESHEET_CONSTANTS.APPROVE),
            className: "bg-app text-white mr-s ",
            hide: false,
            onClick: (data, value) => {
                const payload = {
                    status: TIMESHEET_CONSTANTS.APPROVED,
                    ids: data.map(data => data.id)
                }
                TimesheetService.updateTimesheetStatus(payload).then(() => {
                    showToast("Timesheets approved", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.REPORTS_API_CONFIG,
                    }
                    getReport(config);
                })
            },
        }

        

        const rejectBtn = {
            title: i18next.t(TIMESHEET_CONSTANTS.REJECT),
            className: "text-white bg-red border-m mr-r ",
            hide: false,
            onClick: (data, value) => {
                const payload = {
                    status: TIMESHEET_CONSTANTS.REJECTED,
                    ids: data.map(data => data.id)
                }
                TimesheetService.updateTimesheetStatus(payload).then(() => {
                    showToast("Timesheets rejected", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.REPORTS_API_CONFIG,
                    }
                    getReport(config);
                })
            },
        }
        

        const createInvoiceBtn = {
            title: i18next.t("Create Invoice"),
            className: "bg-app text-white mr-s",
            hide: true,
            condition: {
                columnCode: "status",
                value: "APPROVED",
            },
            onClick: (data, value) => {
                const payload = {
                    timesheetIds: data.map(data => data.id)
                }
                TimesheetService.createInvoice(payload).then(
                    (response) => {
                        showToast(
                            "Invoice created successfully",
                            TOAST_TYPE.SUCCESS
                        );
                    }, (error) => {
                        showToast(error?.error, TOAST_TYPE.FAILURE);
                    }
                );
            },
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.APPROVE])) {
            menuBtn.push(approveBtn)
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.REJECT])) {
            menuBtn.push(rejectBtn)
        }
        //note : will use in future
        // if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.CREATE,ACTION.EDIT, ACTION.SUBMIT, ACTION.APPROVE, ACTION.REJECT])) {
        //     menuBtn.push(createInvoiceBtn)
        // }
        return menuBtn
    }
    return (
        <>
            {showAddTimesheet &&
                <AddTimesheetReport
                    onClose={(refresh) => {
                        setShowAddTimesheet(false);
                        if (refresh) {
                            getReport({ ...TimesheetService.REPORTS_API_CONFIG });
                        }
                    }}
                />
            }
            {showDateRangePicker && renderDateRangePicker()}
            {filterCustomerPopup.show && (
                  <DKListPicker2
                    data={[{id:'all',name:'All'},...customer]}
                    className="position-absolute border-m shadow-m "
                    style={{ top: 70, right: 360, zIndex: 99999 }}
                    renderer={(index, c) => {
                        return (c.name);
                    }}
                    
                    onSelect={(index, value) => {
                         let config= {
                            ...TimesheetService.REPORTS_API_CONFIG,
                            fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                            toDate: toDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ")   
                        }
                        if(value.id !=='all') {
                            config['customerId']= value.id 
                        } else {
                            delete config['customerId']
                        }
                        TimesheetService.REPORTS_API_CONFIG = {...config}
                        getReport(config);
                    

                    setFilterCustomerPopup({
                        ...filterCustomerPopup,
                        value:value.name,
                        show:false
                    })

                    }}
                    onClose={(e) => setFilterCustomerPopup({...filterCustomerPopup,show:false})}
                  />
                )}
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DKButton
                        icon={ic_arrow_back}
                        title={t("BACK")}
                        className="pl-0 p-v-0 pr-0 cursor-hand fw-b mb-s"
                        onClick={() => {
                            RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_REPORT_LIST);
                        }}
                    />

                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_TIMESHEET_REPORT}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_TIMESHEET_REPORT]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={true}
                        allowFilter={true}
                        allowExpand={false}
                        allowRowEdit={false}
                        isMenuVisible={true}
                        showContextMenu={true}
                        showContextEdit={false}
                        onRowDelete={onRowDelete}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onRowExpand={(data) => {
                            updateRowExpanded(data);
                        }}
                        refresh={refresh}
                        allowRowAdd={true}
                        addButtonConfig={addButtonConfig()}

                        addMenuButton={addMenuButton()}
                        onApproveReject={onApproveReject}
                        allowDataExport={false}
                        gridData={timesheetData}
                        onSearch={onSearch}
                        onFilter={onFilter}
                        filter={filterArray}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...TimesheetService.REPORTS_API_CONFIG,
                                currentPage: requestedPageNumber,
                            };
                            getReport(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={true}
                        contextMenu={true}
                        onSelection={onRowSelect}
                        allowColumnSort={false}
                        onColumnShift={(data)=> setReload(!reload)}
                        module={MODULE.TIMESHEET}
                    />
                </div>
            </div>
        </>
    );
}

export default TimesheetReport;
